import { IuseProductHasAttrsResult } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useState } from "react";
import { Col, Collapse, Row } from "@/utils/bootstrap";
import AgreeTermsCheckbox from "@/app/components/pages-components/common/agree-terms/AgreeTermsCheckbox";
import SvgConsultSubmit from "../consult-form-icons/SvgConsultSubmit";
import DisbledReasonModal from "./DisbledReasonModal";
import Price from "@/app/components/lib/Price";
import SvgCartDisabled from "@/app/components/pages-components/product-details-page/details-belpers/details-add-to-cart-btn/details-add-to-card-icons/SvgCartDisabled";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import DisbledReplyReasonModal from "@/app/components/pages-components/user-pages/consultations-page/all-consultations/consultation/consultation-helpers/DisbledReplyReasonModal";
import { IReply } from "@/app/components/pages-components/user-pages/consultations-page/consultations-details/ConsultationsDetails";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useSellingMode from "@/hooks/useSellingMode";
import ProtectedContent from "../../../product/product-box/product-box-helpers/ProtectedContent";
interface Props {
  productState: IuseProductHasAttrsResult;
  isDetails?: boolean;
  reply?: IReply;
}
const ConsultSubmitSection: React.FC<Props> = ({
  productState,
  isDetails = false,
  reply,
}) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const [agree, setAgree] = useState(false);
  const [showReason, setShowReason] = useState(false);
  const { enableAddToCart } = useSellingMode();
  const submitDisabled =
    !agree || productState?.cartDisabled || reply?.disableReply;
  const { shouldConfig, variantNotExist, requiredAddonsNotChosen, outOfStock } =
    productState ?? {};
  return (
    <>
      {!reply && showReason && (
        <DisbledReasonModal
          agree={agree}
          productState={productState}
          show={showReason}
          setShow={setShowReason}
        />
      )}
      {reply && showReason && (
        <DisbledReplyReasonModal
          agree={agree}
          reason={reply.disabledReason!}
          show={showReason}
          setShow={setShowReason}
        />
      )}
        <Row className="m-0 consult-submit-section">
          <Col
            className="p-0"
            xs={mobile || isDetails ? 12 : false}
            style={isDetails ? { margin: mobile ? "16px 0" : "24px 0" } : {}}
          >
            <AgreeTermsCheckbox
              checked={agree}
              setChecked={setAgree}
              terms={productState?.currentProd?.custom_data?.term_and_condition}
            />
          </Col>
          <Col className={`p-0 ${mobile || isDetails ? "" : "col-auto"}`}>
      <ProtectedContent
        smallText
        showChildren={enableAddToCart}
        containerBackground="#acacac"
      >
            <Row className="m-0 justify-content-between">
              {!isDetails && !reply && (
                <Col className="p-0 col-auto">
                  <Collapse
                    in={!productState?.shouldConfig}
                    dimension={mobile ? "width" : "height"}
                  >
                    <div
                      style={{
                        height: 36,
                        width: "fit-content",
                        paddingInlineEnd: 16,
                      }}
                    >
                      <Price
                        sameLine={!mobile}
                        priceFirst={!mobile}
                        gap={mobile ? 4 : 10}
                        price={{
                          value: productState?.currentProd?.price,
                          className: "consult-price",
                        }}
                        priceWithoutDiscount={{
                          value:
                            productState?.currentProd?.price_without_discount,
                          className: "consult-price-without-discount",
                          currSymbol: true,
                        }}
                        roundPrice
                      />
                    </div>
                  </Collapse>
                </Col>
              )}
              <Col className={`p-0 ${isDetails ? "" : "col-auto"}`}>
                <CustomButton
                  isSubmit={!submitDisabled}
                  type={BtnTypes.primary}
                  size={BtnSizes.small}
                  radius={BtnRadius.small}
                  disabled={submitDisabled}
                  notAllowed={productState?.cartDisabled}
                  onClick={() => (submitDisabled ? setShowReason(true) : null)}
                >
                  {productState?.cartDisabled ? (
                    <SvgCartDisabled />
                  ) : (
                    <SvgConsultSubmit />
                  )}
                  {shouldConfig
                    ? t.choose_consultation
                    : variantNotExist
                    ? t.this_consultation_not_available
                    : outOfStock
                    ? t.out_of_stock
                    : requiredAddonsNotChosen
                    ? t.choose_required_addons
                    : productState?.cartDisabled
                    ? t.sell_disabled
                    : !reply
                    ? t.submit
                    : reply.btn_text}
                </CustomButton>
              </Col>
            </Row>
      </ProtectedContent>
          </Col>
        </Row>
    </>
  );
};

export default ConsultSubmitSection;
